import { MatDateFormats } from '@angular/material/core';

export const APP_VERSION = '1.3.5';

export const APP_DATE_FORMAT = 'dd MMM yyyy';
export const APP_DATE_TIME_FORMAT = 'dd MMM yyyy, hh:mm a';
export const APP_NATIVE_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: APP_DATE_FORMAT,
    },
    display: {
        dateInput: APP_DATE_FORMAT,
        monthYearLabel: 'MMM yyyy',
        dateA11yLabel: APP_DATE_FORMAT,
        monthYearA11yLabel: 'MMMM yyyy',
    },
};

export const SINGAPORE_CODE = '+65';
export const COMPANY_ADDRESS = '108, International Road, Singapore 629173';
export const COMPANY_PHONE = '+65 6265 3155';
export const COMPANY_FAX = '+65 6265 8494';
export const COMPANY_EMAIL = 'sales@umweepl.com.sg';

export const APP_AMOUNT_FORMAT = '1.0-2';
export const APP_PRICE_FORMAT = '1.2-2';
export const APP_PRICE_PREVIEW_FORMAT = '1.0-0';

export const YOUTUBE_EMBED_URL = 'https://www.youtube.com/embed/';

export const ONEMAP_EMPTY_RESULT = 'NIL';

export const RENTAL_AGREEMENT_FILE_NAME = 'SimeUMW_RentalAgreement';
export const RENTAL_GUIDE_BOOK_FILE_NAME = 'Rental_Guide_Book_(4.12.2024)_with_SimeUMW';
export const FILE_ASSET_ROUTE = 'assets/files/';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const appTemplateVersion = '1.3.0'; // Only used as reference for template version.
